import {Flex, Space, Tag} from 'antd';
import {ReactElement, useMemo} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {getReviewLogUserDisplayName, ReviewTagLogGroupType} from '../../../../../../../../service/reviews/reviews-logs';
import {classNames} from '../../../../../../../../util/css';
import {LogActionsEnum} from '../../../../../review-logs/review-log-type';
import * as tagListStyles from '../../../../../tag-list/tag-list.scss';

import * as styles from './history-modal.scss';

type PropsType = {
    companyDisplayName: string;
    formattedDate: string | null;
    formattedTime: string | null;
    group: ReviewTagLogGroupType;
};

export function HistoryTagLog(props: PropsType): ReactElement {
    const {companyDisplayName, formattedDate, formattedTime, group} = props;

    const knownUserDisplayName = group.user ? getReviewLogUserDisplayName(group.user) : null;
    const hasKnownUser = Boolean(knownUserDisplayName);

    const actionLocaleString = useMemo(() => {
        const isCreated = group.action === LogActionsEnum.Created;

        if (hasKnownUser) {
            return isCreated
                ? 'REVIEWS__REVIEW_LOG__TAG__CREATED_BY_USER'
                : 'REVIEWS__REVIEW_LOG__TAG__DELETED_BY_USER';
        }

        return isCreated ? 'REVIEWS__REVIEW_LOG__TAG__CREATED' : 'REVIEWS__REVIEW_LOG__TAG__DELETED';
    }, [group.action, hasKnownUser]);

    const userDisplayName = knownUserDisplayName ?? companyDisplayName;

    return (
        <Flex gap={4} vertical>
            <Text secondary>
                {formattedDate} {formattedTime}
            </Text>
            <Flex align="center" gap={4} wrap>
                <Text lighter stringKey={actionLocaleString} valueMap={{user: <Text bolder>{userDisplayName}</Text>}} />
                <Space size={8} wrap>
                    {group.tagTitles.map((title) => (
                        <Tag
                            className={classNames(styles.HistoryModal_tagChip, tagListStyles.TagList_itemTag)}
                            key={title}
                        >
                            {title}
                        </Tag>
                    ))}
                </Space>
            </Flex>
        </Flex>
    );
}
